import { createContext } from 'react';

export const ContextapiUrl = createContext<string | null>(null);
export const ContextRole = createContext<string | null>(null);
